"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNetwork = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var solana_headless_react_1 = require("@hermis/solana-headless-react");
var react_1 = require("react");
// Network endpoints
var NETWORK_ENDPOINTS = {
    devnet: "https://api.devnet.solana.com",
    testnet: "https://api.testnet.solana.com"
};
var NetworkContext = (0, react_1.createContext)(undefined);
var useNetwork = function () {
    var context = (0, react_1.useContext)(NetworkContext);
    if (!context) {
        throw new Error('useNetwork must be used within a NetworkProvider');
    }
    return context;
};
exports.useNetwork = useNetwork;
var WalletContextProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)('devnet'), currentNetwork = _b[0], setCurrentNetwork = _b[1];
    var _c = (0, react_1.useState)(false), isChangingNetwork = _c[0], setIsChangingNetwork = _c[1];
    var currentEndpoint = NETWORK_ENDPOINTS[currentNetwork];
    var changeNetwork = (0, react_1.useCallback)(function (network) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (network === currentNetwork)
                        return [2 /*return*/];
                    setIsChangingNetwork(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    // Small delay to show loading state
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                case 2:
                    // Small delay to show loading state
                    _a.sent();
                    setCurrentNetwork(network);
                    return [3 /*break*/, 4];
                case 3:
                    setIsChangingNetwork(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [currentNetwork]);
    var networkContextValue = {
        currentNetwork: currentNetwork,
        currentEndpoint: currentEndpoint,
        changeNetwork: changeNetwork,
        isChangingNetwork: isChangingNetwork
    };
    return ((0, jsx_runtime_1.jsx)(NetworkContext.Provider, { value: networkContextValue, children: (0, jsx_runtime_1.jsx)(solana_headless_react_1.HermisProvider, { network: solana_headless_react_1.TWalletAdapterNetwork.Devnet, endpoint: currentEndpoint, autoConnect: true, storageKey: "solana-wallet-name-".concat(currentNetwork), children: children }, currentNetwork) }));
};
exports.default = WalletContextProvider;
